import { ROUTE_AUTH, ROUTE_ADMIN, ROUTE_TRADER, ROUTE_API } from '@klear/constants'
import { APP_ENV_LOCAL } from '@klear/constants/app-env'

export function getApiOrigin(): string {
  return process.env.BUN_PUBLIC_API_ORIGIN ?? ''
}

export function getBuildSha(): string {
  return process.env.BUN_PUBLIC_BUILD_SHA ?? ''
}

export function getAppEnv(): string {
  return process.env.BUN_PUBLIC_APP_ENV ?? APP_ENV_LOCAL
}

export function toAbsoluteUrl(baseUrl: string, route: string): string {
  return `${baseUrl}${getAppBasePath(route)}`
}

export function getApiUrl(): string {
  return toAbsoluteUrl(getApiOrigin(), ROUTE_API)
}

export function getAuthBaseUrl(): string {
  return toAbsoluteUrl(process.env.BUN_PUBLIC_AUTH_URL ?? '', ROUTE_AUTH)
}

export function getAdminBaseUrl(): string {
  return toAbsoluteUrl(process.env.BUN_PUBLIC_ADMIN_URL ?? '', ROUTE_ADMIN)
}

export function getTraderBaseUrl(): string {
  return toAbsoluteUrl(process.env.BUN_PUBLIC_TRADER_URL ?? '', ROUTE_TRADER)
}

const KEEP_BASE_PATH = new Set<string>([ROUTE_TRADER, ROUTE_API])

export function getAppBasePath(route: string): string {
  if (!KEEP_BASE_PATH.has(route)) return ''
  return `/${route}`
}
